// Эцэг эхийн нүүр — зөвхөн эцэг эхийн тухай (хүүхдийн мэдээлэл /child хуудсанд):
// мэндчилгээ → зарлал → асуулга → хийх зүйлс (+ зөвлөхтэй уулзалт захиалах) → удахгүй болох уулзалтууд → сургалт.
// Бүгд /guardian/dashboard-аас.
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Spin } from "antd";
import dayjs from "dayjs";
import { instance } from "utils/axios";
import { AuthContext } from "contexts";
import { DOW_FULL } from "./AttendanceDays";
import { Announcements, TodoCard, Upcoming, MeetingSection, LearningSection } from "./ParentDashboard";
import { ElemHero, ElemWeekStrip, useKids } from "pages/Elem/shared";
import ElemTodoCard from "pages/Elem/ElemTodoCard";
import SurveyCards from "pages/Survey/Cards";

function ParentHome() {
  const { state } = useContext(AuthContext);
  const profile = state.studentInfo?.profile || {};
  const [dash, setDash] = useState(null);
  useEffect(() => {
    instance({ method: "get", url: "/guardian/dashboard" })
      .then((res) => setDash(res.data || {}))
      .catch(() => setDash({}));
  }, []);

  // Зарлалыг хаах — шууд нууна
  const dismiss = (id) => {
    setDash((d) => ({ ...d, announcements: d.announcements.filter((a) => a.id !== id) }));
    instance({ method: "post", url: `/guardian/announcements/${id}/dismiss`, silent: true }).catch(() => {});
  };
  // Бага ангийн хүүхэд (v0.1): hero (хүүхэд + энэ 7 хоногийн төсөл), хүүхдийн даалгавар
  const kids = useKids();
  const elemKids = (kids || []).filter((k) => k.elem);
  // Ганц хүүхэд, бага анги бол дизайны том hero (мэндчилгээтэй); олон хүүхэдтэй бол жижиг мөр
  const onlyElem = elemKids.length === 1 && (kids || []).length === 1;
  const [elemOv, setElemOv] = useState([]);
  const elemKey = elemKids.map((k) => k.id).join(",");
  useEffect(() => {
    if (!elemKey) return;
    Promise.all(elemKey.split(",").map((id) => instance({ method: "get", url: `/student/elem/${id}/overview` }).then((r) => r.data).catch(() => null)))
      .then((list) => setElemOv(list.filter(Boolean)));
  }, [elemKey]);
  const greet = useMemo(() => {
    const h = dayjs().hour();
    return h < 12 ? "Өглөөний мэнд" : h < 18 ? "Өдрийн мэнд" : "Оройн мэнд";
  }, []);
  // Уулзалт захиалах нь хийх зүйлс биш — "Зөвлөхтэй уулзалт" хэсэгт тусдаа
  const allTodos = dash?.todos || [];
  const todos = allTodos.filter((t) => t.kind !== "booking");
  const booking = allTodos.find((t) => t.kind === "booking");
  const showTodos = todos.some((t) => !t.done);

  return (
    <div className="pt-3.5 md:pt-7 pb-6 md:pb-14 max-w-[1180px] mx-auto flex flex-col gap-3.5 md:gap-5">
      {!onlyElem && <header className="pt-1 md:pt-2">
        <h1 className="m-0 text-[28px] md:text-[40px] font-extrabold leading-tight tracking-[-0.02em] text-[#1c1c1c]">
          {greet}{profile.firstName ? `, ${profile.firstName}` : ""}
        </h1>
        <p className="m-0 mt-1 text-sm md:text-base text-[#6e5e8a]">{dayjs().format("M")}-р сарын {dayjs().format("D")}, {DOW_FULL[dayjs().day()]}</p>
      </header>}

      {onlyElem
        ? elemOv.map((ov) => <ElemHero key={ov.student.id} ov={ov} greet={greet} parentName={profile.firstName} />)
        : elemOv.map((ov) => <ElemWeekStrip key={ov.student.id} ov={ov} />)}

      {!dash && <div className="flex justify-center py-10"><Spin /></div>}

      {dash?.announcements?.length > 0 && <Announcements list={dash.announcements} onDismiss={dismiss} />}

      {/* Сэтгэл ханамжийн асуулга — popup бол нэг удаа автоматаар нээгдэнэ */}
      <SurveyCards />

      {dash && (showTodos || booking || elemOv.some((o) => o.tasks.length)) && (
        <div className="flex flex-wrap gap-3.5 md:gap-5 items-start">
          {elemOv.some((o) => o.tasks.length)
            ? <div className="flex-[1.618_1_440px] min-w-0"><ElemTodoCard overviews={elemOv} todos={todos} /></div>
            : showTodos && <div className="flex-[1.618_1_440px] min-w-0"><TodoCard todos={todos} /></div>}
          <MeetingSection upcoming={dash.upcoming} booking={booking} className="flex-[1_1_320px] min-w-0" />
        </div>
      )}

      {dash && <Upcoming upcoming={dash.upcoming} />}

      <LearningSection learning={dash?.learning} />

    </div>
  );
}

export default ParentHome;
